import { DateFormatter } from '@repo/toolkit/date'

import { TripScheduleFilters } from '../../types/models/trips-schedule/trip-schedule'

export const transformTripScheduleFiltersToUrl = (filters?: TripScheduleFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.date) searchParams.append('date', filters.date)

  return searchParams.toString()
}

export const transformUrlToTripScheduleFilters = (
  searchParams: URLSearchParams
): TripScheduleFilters => {
  const filters: TripScheduleFilters = { date: DateFormatter.toDateFormatted(new Date()) }

  const date = searchParams.get('date')
  if (date) filters.date = date

  return filters
}
